//debounced time
export const DEBOUNCE_TIME = 800;

export const MAX_RETRY_ATTEMPTS = 3;
